import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout';
import { TransactionForm, TransactionStatus } from '@/components/features/transactions';
import type { Transaction } from '@/types';

/**
 * Transaction trigger page.
 * Route: /transactions/trigger
 *
 * Allows platform_admin and merchant_admin users to create
 * test payment transactions against the MNO Facade.
 */
export function TransactionTriggerPage() {
  const { t } = useTranslation('transactions');
  const [transaction, setTransaction] = React.useState<Transaction | null>(null);

  const handleSuccess = (createdTransaction: Transaction) => {
    setTransaction(createdTransaction);
  };

  const handleReset = () => {
    setTransaction(null);
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('page.title')}
        description={t('page.description')}
      />

      {transaction ? (
        <TransactionStatus transaction={transaction} onReset={handleReset} />
      ) : (
        <TransactionForm onSuccess={handleSuccess} />
      )}
    </div>
  );
}
